import React from 'react';
import { testimonials } from '../../data/testimonials';
import { SectionIntro } from '../SectionIntro';
export function Testimonials() {
  if (testimonials.length === 0) return null;
  return <section className="border-t border-rule bg-ivory" data-id="element-208" data-mp="3mgae0g1vxanq">
      <div className="mx-auto max-w-site px-5 py-20 md:px-8 lg:py-24" data-id="element-209" data-mp="3meplevz4s1si">
        <SectionIntro label="From Technicians" title="What technicians say." data-id="element-210" data-mp="3r8akysgdh3tt" />
        <ul className="mt-12 grid gap-8 md:grid-cols-2" data-id="element-211" data-mp="1zdadgux4ti">
          {testimonials.map(t => <li key={t.name} className="border-t-2 border-ink pt-6" data-id="element-212" data-mp="421gws65k8bf">
              <blockquote className="text-[18px] leading-[1.65] text-ink" data-id="element-213" data-mp="91w6mse6yruw">“{t.quote}”</blockquote>
              <p className="mt-4 text-[15px] font-semibold text-ink" data-id="element-214" data-mp="e0z15iwjpfom">{t.name}</p>
              <p className="text-[14px] text-inkSoft" data-id="element-215" data-mp="dywcp3b1jum0">{t.role}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}